import useEnvService from '@hooks/app/useEnvService';
import React from 'react';
import { useParams } from 'react-router-dom';
import BaseInfoLife from './base-info-life';
import BaseInfoPatient from './base-info-patient';
import { BaseInfoSC } from './base-info.styled';

interface BaseInfoProps {
  videoIndicatorStatus?: boolean;
}

const BaseInfo: React.FC<BaseInfoProps> = ({ videoIndicatorStatus }) => {
  const params = useParams<{ userId: string; jabberId: string }>();
  const { userId } = params;

  const [env] = useEnvService();
  const chatWithHilbi = userId === env.xmpp.hilbiId;
  // const patients = useAppSelector((store) => store.patients);
  // const patient = patients.patients.find((patient: any) => patient.from.id === userId);

  const handleBtnClick = (agreementUrl: string) => {
    window.open(agreementUrl);
  };

  return (
    <BaseInfoSC>
      <div className="bi-avatar-col">
        <BaseInfoPatient videoIndicatorStatus={videoIndicatorStatus} />
        {/* {!chatWithHilbi && patient.agreement && (
          <Button
            size="MD"
            mt={18}
            kind="PRIMARY"
            className="bi-avatar-btn"
            onClick={() => handleBtnClick(patient.agreement)}
          >
            <FormattedMessage id="profile.get_user_agreement" />
          </Button>
        )} */}
      </div>
      <div className="bi-info-col">
        <BaseInfoLife />
      </div>
    </BaseInfoSC>
  );
};

export default BaseInfo;
